<div class="brands-selection-panel">
  
  <ng-container *ngIf="!displayUserRelatedBrand; else userRelatedBrandTemplate">
    <div class="brands-container">
        <app-brand-chip *ngIf="myBrand"
          [attr.data-testid]="DataTestIds.MY_BRAND_CHIP"
          [label]="myBrand.label"
          [key]="myBrand.key"
          [color]="myBrand.color"
          [icon]="myBrand.icon"
          [group]="myBrand.group"
          [disabled]="false"
          [displayRemoveButton]="false"
          [brandsOptions]="myBrandOptions"
          [isTrialUser]="isTrialUser"
          (brandChanged)="onMyBrandChanged($event)"
        ></app-brand-chip>
      <span 
        class="vs-label"
        [ngClass]="{'disabled': !myCompetitors?.length || isMyCompetitorsDisabled}">
        vs.
      </span>
      <ng-container *ngIf="myCompetitors?.length; else noCompetitors">
        <app-brand-chip 
          [matTooltip]="isMyCompetitorsDisabled ? tooltips.disableCompetitors : null"
          *ngFor="let item of myCompetitors"
          [label]="item.label"
          [key]="item.key"
          [color]="item.color"
          [icon]="item.icon"
          [group]="item.group"
          [disabled]="isMyCompetitorsDisabled"
          [displayRemoveButton]="shouldDisplayRemoveButton"
          [brandsOptions]="myCompetitorsOptions"
          [isCompetitor]="true"
          (brandChanged)="onCompetitorChanged($event, item.key)"
          (brandRemoved)="onCompetitorRemoved($event)"
        ></app-brand-chip>
      </ng-container>
    </div>
    <ng-container *ngIf="shouldDisplayAddButton">
      <app-brand-chip-add-button
        [@fadeInOut]
        [isTrialUser]="isTrialUser"
        [brandsOptions]="myCompetitorsOptions"
        (brandSelected)="onCompetitorAdded($event)"
      ></app-brand-chip-add-button>
    </ng-container>
    <ng-template #noCompetitors>
      <div 
        class="no-competitors-label"
        [matTooltip]="tooltips.noCompetitors" 
        matTooltipClass="no-competitors-tooltip">
        {{ NO_COMPETITORS_ASSIGNED }}
      </div>
    </ng-template>
  </ng-container>

  <ng-template #userRelatedBrandTemplate>
    <div class="brands-container">
      <app-brand-chip *ngIf="userRelatedBrand"
        [attr.data-testid]="DataTestIds.MY_BRAND_CHIP"
        [label]="userRelatedBrand.label"
        [key]="userRelatedBrand.key"
        [color]="userRelatedBrand.color"
        [icon]="userRelatedBrand.icon"
        [group]="userRelatedBrand.group"
        [disabled]="false"
        [displayRemoveButton]="false"
        [displayBrandColor]="false"
        [brandsOptions]="userRelatedBrandOptions"
        (brandChanged)="onUserRelatedBrandChanged($event)"
      ></app-brand-chip>
    </div>
  </ng-template>
</div>
